
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","x2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#004387"}}),_c('stop',{attrs:{"offset":".399","stop-color":"#156ba7"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#34a3d4"}})])]),_c('g',{attrs:{"data-name":"Group 12099","transform":"translate(-1700 -382)"}},[_c('circle',{attrs:{"data-name":"Ellipse 172","cx":"15","cy":"15","r":"15","transform":"translate(1700 382)","fill":"url(#a)"}}),_c('g',{attrs:{"data-name":"Group 13955"}},[_c('path',{attrs:{"data-name":"Union 45","d":"M1715.439 392a1.308 1.308 0 011.161.649l5.9 5.9a1.308 1.308 0 11-1.854 1.845l-5.207-5.208-5.209 5.208a1.309 1.309 0 01-1.852-1.849l5.9-5.9a1.308 1.308 0 011.13-.65z","fill":"#fff"}})])])])
          )
        }
      }
    